import PropTypes from "prop-types";

import { headingCss } from "./ReportContentFormHeading.style";

const propTypes = {
  customStyles: PropTypes.object,
  id: PropTypes.string,
  level: PropTypes.oneOf(["h1", "h2", "h3", "h4", "h5", "h6"]),
  text: PropTypes.string,
};

const defaultProps = {
  customStyles: {},
  level: "h4",
  text: "Report content",
};

const ReportContentFormHeading = ({
  id,
  customStyles,
  level: HeadingLevel,
  text,
}) => {
  return (
    <HeadingLevel id={id} css={[headingCss, customStyles]}>
      {text}
    </HeadingLevel>
  );
};

ReportContentFormHeading.defaultProps = defaultProps;
ReportContentFormHeading.propTypes = propTypes;

export default ReportContentFormHeading;
